import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import {
  IGetServiceProps,
  IGlobalMetaSchema,
} from "@api/types/globalService.types";
import { ICouponsResponseSchema } from "@api/types/couponsService.types";
import { urlUtility } from "@repo/utilities/url.utility.ts";

interface IGetAllCouponsService {
  data: ICouponsResponseSchema[];
  meta: IGlobalMetaSchema;
}

export const useGetAllCouponsService = ({
  page = "1",
  per_page = "15",
  showActiveOnly = true,
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const partnerId = +urlQueries["partner-id"] || "";
  const planId = +urlQueries["plan-id"] || "";
  const created_between = urlQueries["created_between"] || "";
  const allCouponsService = useQuery({
    queryKey: [
      ...CACHE_KEYS.COUPONS,
      debouncedQuery,
      page,
      per_page,
      showActiveOnly,
      planId,
      partnerId,
      created_between,
    ],
    queryFn: (): Promise<IGetAllCouponsService> =>
      handleGlobalGetRequestQuery({
        url: URLS.COUPONS,
        searchParams: {
          page,
          per_page,
          "filter[plan_id]": debouncedQuery,
          "filter[created_between]": created_between,
          include: "plan",
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchQuery, setSearchQuery },
    services: { allCouponsService },
  };
};
